import { TemplateEngine } from "../../utils/TemplateEngine.js";
import { AuthService } from "../../services/AuthService.js";
import navbarTemplate from "./navbar.html?raw";

const iniciales = (usuario) => {
  const n = (usuario?.Nombre || "").trim()[0] || "";
  const a = (usuario?.Apellido || "").trim()[0] || "";
  return (n + a).toUpperCase() || "?";
};

export const Navbar = {
  /**
   * Devuelve el HTML del topbar. `opciones.volver` cambia el logo por una flecha atrás
   * y muestra el título de la pantalla (se usa en el detalle de póliza).
   */
  render(opciones = {}) {
    const usuario = AuthService.getUsuario() || {};
    return TemplateEngine.render(navbarTemplate, {
      MostrarVolver: !!opciones.volver,
      Titulo: opciones.titulo || "",
      Sobretitulo: opciones.sobretitulo || "",
      Nombre: AuthService.getNombreCorto() || "asegurado",
      NombreCompleto: ((usuario.Nombre || "") + " " + (usuario.Apellido || "")).trim(),
      Email: usuario.Email || "",
      Iniciales: iniciales(usuario),
    });
  },

  /** Bindea los eventos del topbar. Llamar DESPUÉS de asignar el innerHTML. */
  bind() {
    document.getElementById("btnCerrarSesion")?.addEventListener("click", () => {
      AuthService.logout();
    });

    document.getElementById("btnVolver")?.addEventListener("click", () => {
      // history.back() volvería fuera de la app si se entró por link directo al detalle.
      if (document.referrer && window.history.length > 1) window.history.back();
      else window.location.hash = "home";
    });
  },
};
